<template>
  <div class="sf-collected-product">
    <slot name="remove" v-bind="{ removeHandler }">
      <SfCircleIcon
        icon="cross"
        aria-label="Remove"
        class="sf-circle-icon--small sf-collected-product__remove sf-collected-product__remove--circle-icon"
        @click="removeHandler"
      />
      <SfButton
        class="sf-button--text sf-collected-product__remove sf-collected-product__remove--text"
        @click="removeHandler"
        >Remove</SfButton
      >
    </slot>
    <div class="sf-collected-product__aside">
      <slot name="image" v-bind="{ image, title }">
        <SfImage
          :src="image"
          :alt="title"
          :width="imageWidth"
          :height="imageHeight"
          class="sf-collected-product__image"
        />
      </slot>
      <slot name="input">
        <div class="sf-collected-product__quantity-wrapper">
          <SfQuantitySelector
            :qty="qty"
            :min="minQty"
            aria-label="Quantity"
            class="sf-collected-product__quantity-selector"
            @input="$emit('input', $event)"
          />
        </div>
      </slot>
    </div>
    <div class="sf-collected-product__main">
      <div class="sf-collected-product__details">
        <slot name="title" v-bind="{ title }">
          <div class="sf-collected-product__title">{{ title }}</div>
          <div class="sf-collected-product__variant-name">
            {{ variantName }}
          </div>
        </slot>
        <slot name="price" v-bind="{ specialPrice, regularPrice }">
          <SfPrice
            v-if="regularPrice"
            :regular="regularPrice | price"
            :special="specialPrice | price"
          />
        </slot>
        <slot name="configuration" />
      </div>
      <div class="sf-collected-product__actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>
<script>
import SfPrice from "../../atoms/SfPrice/SfPrice.vue";
import SfImage from "../../atoms/SfImage/SfImage.vue";
import SfCircleIcon from "../../atoms/SfCircleIcon/SfCircleIcon.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfQuantitySelector from "../../atoms/SfQuantitySelector/SfQuantitySelector.vue";
export default {
  name: "SfCollectedProduct",
  components: {
    SfButton,
    SfImage,
    SfCircleIcon,
    SfPrice,
    SfQuantitySelector,
  },
  model: {
    prop: "qty",
  },
  props: {
    image: {
      type: [String, Object],
      default: "",
    },
    imageWidth: {
      type: [String, Number],
      default: 100,
    },
    imageHeight: {
      type: [String, Number],
      default: 70,
    },
    /**
     * Product title
     */
    title: {
      type: String,
      default: "",
    },
    variantName: {
      type: String,
      default: "",
    },
    /**
     * Product regular price
     */
    regularPrice: {
      type: [Number, String],
      default: null,
    },
    /**
     * Product special price
     */
    specialPrice: {
      type: [Number, String],
      default: null,
    },
    /**
     * Selected quantity
     */
    qty: {
      type: [Number, String],
      default: 1,
    },
    minQty: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    removeHandler() {
      this.$emit("click:remove");
    },
  },
};
</script>
<style lang="scss">
@import "~@lib/styles/components/organisms/SfCollectedProduct.scss";
</style>
